import { useGetListingQuery } from '../../RTK/api/reservations';
import { useGetStoresQuery } from '../../RTK/api/store';
import {
  selectReservationRecentSearch,
  recentlyStoreSearchedSelector,
} from '../../RTK/search/selectors';

import HomeCard from './components/HomeItem';
import ReservationCard from './components/ReservationItem';
import { TYPE } from './types';

export const SEARCH_SELECTOR = {
  [TYPE.HOME]: recentlyStoreSearchedSelector,
  [TYPE.RESERVATION]: selectReservationRecentSearch,
};

export const TYPE_CARD = {
  [TYPE.HOME]: HomeCard,
  [TYPE.RESERVATION]: ReservationCard,
};

export const TYPE_PLACEHOLDER = {
  [TYPE.HOME]: 'Looking for something?',
  [TYPE.RESERVATION]: 'Search for Restaurants, Events...',
};

export const TYPE_STATUS = {
  [TYPE.HOME]: 'success',
  [TYPE.RESERVATION]: 'info',
};

export const useQuery = {
  [TYPE.HOME]: useGetStoresQuery,
  [TYPE.RESERVATION]: useGetListingQuery,
};
